import { useQuery, type UseQueryResult } from '@tanstack/react-query';

import { apiClient, fleetPath } from '@/lib/api-client';
import { adaptSummary, type ApiSummary } from '@/lib/fleet-adapters';
import type { FleetSummary } from '@/types/fleet';

import { fleetKeys } from './fleet-keys';

export function useFleetSummary(): UseQueryResult<FleetSummary, Error> {
  return useQuery({
    queryKey: fleetKeys.summary(),
    queryFn: async ({ signal }) =>
      adaptSummary(await apiClient.get<ApiSummary>(fleetPath('/summary'), signal)),
    // The API also caches /summary 60s server-side; matching it client-side
    // avoids redundant requests on every 30s table poll.
    staleTime: 60_000,
  });
}
